export default {
    getData (state) {
        return state.data
    },
    getUserLang (state) {
        return state.userLang
    },
    getLang (state) {
        return state.lang
    }
}


// WEBPACK FOOTER //
// ./src/vuex/getters.js